import { render } from "./OptimizeWizard.vue?vue&type=template&id=2fd3bb79&scoped=true"
import script from "./OptimizeWizard.vue?vue&type=script&lang=js"
export * from "./OptimizeWizard.vue?vue&type=script&lang=js"

import "./OptimizeWizard.vue?vue&type=style&index=0&id=2fd3bb79&scoped=true&lang=css"

import exportComponent from "E:\\Documents\\Github\\OpticTool\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fd3bb79"]])

export default __exports__